import type {
  ChannelBinding,
  CitizenCardData,
  CitizenCardPreferences,
} from '../types/citizen';

export const DEMO_AVATAR_URL = `${import.meta.env.BASE_URL}demo-citizen.svg`;

export const DEFAULT_PREFERENCES: CitizenCardPreferences = {
  showMilitaryRank: true,
  showBuilderRank: true,
  showTotalDamage: true,
  showBuildingProgress: true,
  showAffiliations: true,
};

export const DEMO_CITIZEN: CitizenCardData = {
  citizen: {
    id: '1842',
    username: 'Aurelius Vale',
    avatarUrl: DEMO_AVATAR_URL,
    avatarBorderUrl: null,
    level: 47,
    citizenSince: '2025-02-16T00:00:00.000Z',
    country: {
      id: '31',
      name: 'Portugal',
      flagUrl: null,
      flagEmoji: '🇵🇹',
    },
  },
  service: {
    militaryRank: {
      name: 'Field Marshal',
      level: 12,
      iconUrl: null,
    },
    builderRank: {
      name: 'Master Architect',
      level: 9,
      iconUrl: null,
    },
    totalDamage: 12_840_650,
    buildingProgress: 68_420,
    achievements: [
      { id: 'iron-vanguard', name: 'Iron Vanguard', imageUrl: null, count: 3 },
      { id: 'city-founder', name: 'City Founder', imageUrl: null, count: 1 },
      { id: 'standard-bearer', name: 'Standard Bearer', imageUrl: null, count: 7 },
    ],
  },
  affiliations: {
    militaryUnit: {
      id: '8',
      name: 'Atlantic Guard',
      avatarUrl: null,
    },
    politicalParty: {
      id: '3',
      name: 'Civic Concord',
      avatarUrl: null,
    },
  },
  registryStatus: 'active',
  publicProfileUrl: 'https://app.eclesiar.com/user/1842',
  updatedAt: new Date().toISOString(),
  preferences: DEFAULT_PREFERENCES,
};

export const DEMO_BINDING: ChannelBinding = {
  connected: true,
  citizenId: DEMO_CITIZEN.citizen.id,
  citizenName: DEMO_CITIZEN.citizen.username,
  preferences: DEFAULT_PREFERENCES,
};
